/*
 * Haye Nii name personalization. The fields are in snippets/name-personalization.liquid.
 * What this file does, step by step:
 *  1. Language buttons (+ the "More" list with Other, assets/hn-lang-more.js) and the "Which language?" box.
 *  2. When the shopper types a name: translate it to the chosen language's letters, then show font previews.
 *     Translation order: our Cloudflare Worker (Theme settings > Name personalization), then 2 free Google
 *     fallbacks. A result only counts if it is really written in that language's letters.
 *     If everything fails, the typed name is kept and the order gets a note ("Translation") for our team.
 *  3. Before Add to cart: name filled in, language given for "Other", translation finished, font chosen.
 *     Otherwise Add to cart is stopped and a clear message is shown.
 * No jQuery. Nothing secret in this file.
 */
(function () {
  if (window.hayeniiNameLoaded) return;
  window.hayeniiNameLoaded = true;

  var MAX_LENGTH = 15;
  var DEVANAGARI = ['Hindi', 'Marathi', 'Nepali', 'Sanskrit'];
  // Languages that have their own field on the order; every other language goes to "Other Language Name"
  var OWN_FIELD = { Punjabi: 'Punjabi', Urdu: 'Urdu', Hindi: 'Devanagari', Marathi: 'Devanagari', Nepali: 'Devanagari', Sanskrit: 'Devanagari' };

  // Letters of each script (Unicode ranges), used to check a translation really is in that language
  var LETTERS = {
    Punjabi: '਀-੿',
    Hindi: 'ऀ-ॿ', Marathi: 'ऀ-ॿ', Nepali: 'ऀ-ॿ', Sanskrit: 'ऀ-ॿ',
    Urdu: '؀-ۿݐ-ݿﭐ-﷿ﹰ-﻿',
    Bengali: 'ঀ-৿', Gujarati: '઀-૿', Tamil: '஀-௿', Telugu: 'ఀ-౿',
    Kannada: 'ಀ-೿', Malayalam: 'ഀ-ൿ', Sinhala: '඀-෿'
  };
  var LANGUAGE_CODE = {
    Punjabi: 'pa', Hindi: 'hi', Marathi: 'mr', Nepali: 'ne', Urdu: 'ur', Bengali: 'bn', Gujarati: 'gu',
    Kannada: 'kn', Malayalam: 'ml', Sinhala: 'si', Tamil: 'ta', Telugu: 'te', Sanskrit: 'sa', English: 'en'
  };
  var LATIN = /^[a-zA-Z0-9\s.,!?'"\-()]+$/;

  // Font choices per language: [font name in assets/hayenii-custom.css, label shown]. The first one is preselected.
  function numbered(prefix, suffix, label, count, extra) {
    var list = [];
    for (var i = 1; i <= count; i++) list.push([prefix + i + suffix, label + ' ' + i]);
    return list.concat(extra || []);
  }
  var FONTS = {
    English: numbered('Font', '', 'Font', 8),
    Punjabi: numbered('Font', 'P', 'ਅੱਖਰ', 8, [['Font11P', 'ਅੱਖਰ 9']]),
    Hindi: numbered('Font', 'H', 'अक्षर', 8),
    // Font8U (Noto Serif Ottoman Siyaq) has no normal Urdu letters, so phones showed a random font: not offered
    Urdu: numbered('Font', 'U', 'فونٹ', 7),
    Bengali: numbered('Font', 'B', 'অক্ষর', 4),
    Gujarati: numbered('Font', 'G', 'અક્ષર', 4),
    Kannada: numbered('Font', 'K', 'ಅಕ್ಷರ', 4),
    Malayalam: numbered('Font', 'M', 'ഫോണ്ട്', 4),
    Sinhala: numbered('Font', 'S', 'අකුරු', 4),
    Tamil: numbered('Font', 'T', 'எழுத்து', 4),
    Telugu: numbered('Font', 'Te', 'ఫాంట్', 4)
  };
  DEVANAGARI.forEach(function (lang) { FONTS[lang] = FONTS.Hindi; });

  function sizeNote(language) {
    if (language === 'Punjabi') return 'About 1 cm tall (fonts 8 and 9 about 2 cm).';
    if (language === 'Urdu') return 'About 1.5 cm tall.';
    return 'About 1 cm tall.';
  }

  // Size a name so ALL of it fits its box: width AND height (fonts 8 and 9 have tall swirls above and below).
  // Measures the real ink of the letters in the chosen font, then picks the biggest size that fits.
  // The box centres the letters (CSS), so nothing is moved here.
  var measureCanvas = document.createElement('canvas').getContext('2d');

  function fitText(el, maxPx) {
    if (!el || !el.clientWidth || !el.textContent) return;
    var style = getComputedStyle(el);
    var roomW = el.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
    var roomH = el.clientHeight - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom);
    measureCanvas.font = style.fontStyle + ' ' + style.fontWeight + ' ' + maxPx + 'px ' + style.fontFamily;
    var m = measureCanvas.measureText(el.textContent);
    var inkW = Math.max(m.width, (m.actualBoundingBoxLeft || 0) + (m.actualBoundingBoxRight || 0));
    var ascent = m.actualBoundingBoxAscent || maxPx * 0.8;
    var descent = m.actualBoundingBoxDescent || maxPx * 0.2;
    var scale = Math.min(1, (roomW * 0.96) / inkW, (roomH * 0.92) / (ascent + descent));
    var size = Math.max(10, Math.floor(maxPx * scale));
    el.style.fontSize = size + 'px';
  }

  function fitAll(root) {
    root.querySelectorAll('.hn-name__font-sample').forEach(function (el) { fitText(el, 26); });
    root.querySelectorAll('.hn-name__preview').forEach(function (el) { fitText(el, 64); });
  }

  // Web fonts arrive a moment later and change the width: fit again then, and when the screen size changes
  if (document.fonts && document.fonts.addEventListener) {
    document.fonts.addEventListener('loadingdone', function () {
      document.querySelectorAll('[data-hn-name]').forEach(fitAll);
    });
  }
  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-hn-name]').forEach(fitAll);
  });

  // ---------- Translation ----------
  var cache = {};

  function isUsable(result, language, original) {
    if (!result) return false;
    if (language === 'English') return LATIN.test(result);
    if (!LETTERS[language]) return result !== original; // "Other" language: at least it must have changed
    return !/[a-zA-Z]/.test(result) && new RegExp('[' + LETTERS[language] + ']').test(result);
  }

  // Already written in the target language's letters? Then no translation is needed.
  function isAlreadyInScript(text, language) {
    if (language === 'English') return LATIN.test(text);
    if (!LETTERS[language]) return false;
    var letters = language === 'Urdu' ? '؀-ۿ' : LETTERS[language];
    return new RegExp('^[' + letters + '‌‍\\s0-9.,!?\'"\\-()]+$').test(text);
  }

  function getJson(url, options) {
    return fetch(url, options).then(function (response) {
      if (!response.ok) throw new Error('HTTP ' + response.status);
      return response.json();
    });
  }

  // Returns the name in the language's letters, or null when every service failed.
  async function translate(text, language, endpoint) {
    var key = 'trans_' + text.toLowerCase() + '_' + language;
    if (isUsable(cache[key], language, text)) return cache[key];
    try {
      var saved = sessionStorage.getItem(key);
      if (isUsable(saved, language, text)) return (cache[key] = saved);
    } catch (e) { /* private browsing */ }

    if (isAlreadyInScript(text, language)) return text;

    var result = null;
    // 1. Our translation service (Cloudflare Worker -> Gemini, by sound). POST {text, language} -> {result}
    if (endpoint) {
      try {
        var data = await getJson(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ text: text, language: language })
        });
        if (data && typeof data.result === 'string' && isUsable(data.result.trim(), language, text)) result = data.result.trim();
      } catch (e) {
        console.warn('Translation service failed, using fallback.', e);
      }
    }

    var code = LANGUAGE_CODE[language];
    var typedInLatin = LATIN.test(text);
    try {
      // 2. Google Input Tools: English letters -> other script, by sound
      if (!result && code && typedInLatin && language !== 'English') {
        var tools = await getJson('https://inputtools.google.com/request?text=' + encodeURIComponent(text) + '&itc=' + code + '-t-i0-und&num=1');
        var guess = tools && tools[0] === 'SUCCESS' && tools[1] && tools[1][0] && tools[1][0][1] && tools[1][0][1][0];
        if (isUsable(guess, language, text)) result = guess;
      }
      // 3. Google Translate: only for names NOT typed in English letters (it translates meaning: "Prem" -> "love")
      if (!result && code && !typedInLatin) {
        var gt = await getJson('https://translate.googleapis.com/translate_a/single?client=gtx&sl=auto&tl=' + code + '&dt=t&q=' + encodeURIComponent(text));
        var translated = gt && gt[0] && gt[0][0] && gt[0][0][0];
        if (isUsable(translated, language, text)) result = translated;
      }
    } catch (e) {
      console.warn('Translation fallback failed.', e);
    }

    // A name in English letters is already fine for an English necklace
    if (!result && language === 'English' && !/[^\u0000-ɏ\s]/.test(text)) result = text;

    if (result) {
      cache[key] = result;
      try { sessionStorage.setItem(key, result); } catch (e) { /* private browsing */ }
    }
    return result;
  }

  // ---------- One name box ----------
  function NameBox(root) {
    this.root = root;
    this.input = root.querySelector('[data-hn-input]');
    this.languageInput = root.querySelector('[data-hn-language]');
    this.otherBox = root.querySelector('[data-hn-other]');
    this.otherInput = root.querySelector('[data-hn-other-input]');
    this.fontInput = root.querySelector('[data-hn-font]');
    this.fontsBox = root.querySelector('[data-hn-fonts]');
    this.preview = root.querySelector('[data-hn-preview]');
    this.count = root.querySelector('[data-hn-count]');
    this.error = root.querySelector('[data-hn-error]');
    this.notice = root.querySelector('[data-hn-notice]');
    this.size = root.querySelector('[data-hn-size]');
    this.note = root.querySelector('[data-hn-note]');
    this.endpoint = root.dataset.endpoint || '';
    this.keepSpaces = root.hasAttribute('data-keep-spaces');
    this.request = 0;
    this.timer = null;
    // What was last translated: the order may only be added when it matches what is typed now
    this.done = { text: null, language: null, failed: false };
    this.translating = false;
    this.more = this.languageInput ? this.moreList() : null;
    this.bind();
    this.syncLanguage();
    this.prefill();
    this.updateSizeNote();
    this.updateCount();
    if (this.input.value.trim()) this.translateNow(); // browser kept the text after "Back" (or the search prefill below)
  }

  // Task 32: the name search ("Want Sidhu on a necklace?") opens the product with ?hn_name=Sidhu(&hn_lang=Punjabi).
  // Same as typing it: only the FIRST name box on the page, only while it is empty, only letters/marks/spaces/'/-.
  // A name longer than the box allows is NOT filled in (never cut short). The language is only chosen when it is one of
  // the buttons already on screen. Read once, then removed from the address (never stored, never shared in a copied link).
  var prefillDone = false;
  NameBox.prototype.prefill = function () {
    if (prefillDone) return;
    prefillDone = true;
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
    // batch B: a language chip (Marathi, Nepali, Sanskrit) opens this page with only ?hn_lang=Marathi
    if (!params.has('hn_name') && !params.has('hn_lang')) return;
    var raw = params.get('hn_name') || '';
    var lang = (params.get('hn_lang') || '').replace(/[^A-Za-z]/g, '');
    try {
      params.delete('hn_name');
      params.delete('hn_lang');
      var rest = params.toString();
      history.replaceState(history.state, '', window.location.pathname + (rest ? '?' + rest : '') + window.location.hash);
    } catch (e) { /* the address keeps it; harmless */ }
    var name = '';
    try { name = raw.replace(/[^\p{L}\p{M}\s'\-]/gu, ''); } catch (e) { name = raw.replace(/[<>"&{}\[\]0-9\/\\=;:!?@#$%^*+|~`]/g, ''); }
    name = name.replace(/\s+/g, ' ').trim();
    if (name.length > MAX_LENGTH || this.input.value.trim()) return;
    if (!name && !lang) return;
    // only a language of this box (one of the 4 buttons or the "More" list; never "Other")
    var known = lang && lang !== 'Other' && this.languageInput &&
      (this.root.querySelector('[data-hn-lang="' + lang + '"]') || (this.more && this.more.has(lang)));
    if (known) this.chooseLanguage(lang); // the box is still empty: nothing translates yet
    if (name) this.input.value = name;
  };

  // The browser may keep the chosen language after "Back": show the same language on the buttons (nothing translates here)
  NameBox.prototype.syncLanguage = function () {
    if (!this.languageInput) return;
    var language = this.languageInput.value || 'English';
    this.root.querySelectorAll('[data-hn-lang]').forEach(function (pill) {
      pill.setAttribute('aria-pressed', pill.dataset.hnLang === language ? 'true' : 'false');
    });
    if (this.more) this.more.set(language);
    var isOther = language === 'Other';
    if (this.otherBox) this.otherBox.hidden = !isOther;
    if (this.otherInput) this.otherInput.disabled = !isOther;
  };

  // batch B: "More" opens the list of the other languages (assets/hn-lang-more.js)
  NameBox.prototype.moreList = function () {
    var box = this;
    var wrap = this.root.querySelector('[data-hn-langs]');
    if (!wrap) return null;
    if (window.hnLangMore) return window.hnLangMore(wrap, function (language) { box.chooseLanguage(language); });
    // that file did not load: the list still opens and closes (no keys), so every language can be chosen
    var button = wrap.querySelector('[data-hn-lang-more]');
    var list = wrap.querySelector('[data-hn-lang-list]');
    if (!button || !list) return null;
    button.addEventListener('click', function () { list.hidden = !list.hidden; });
    list.addEventListener('click', function (event) {
      var item = event.target.closest('[data-value]');
      if (!item) return;
      list.hidden = true;
      box.chooseLanguage(item.getAttribute('data-value'));
    });
    return {
      has: function (value) { return !!list.querySelector('[data-value="' + value + '"]'); },
      set: function (value) {
        var chosen = list.querySelector('[data-value="' + value + '"]');
        list.querySelectorAll('[data-value]').forEach(function (item) { item.setAttribute('aria-selected', item === chosen ? 'true' : 'false'); });
        var label = wrap.querySelector('[data-hn-lang-more-label]');
        if (label) label.textContent = chosen ? value : 'More';
        if (chosen) button.setAttribute('data-chosen', ''); else button.removeAttribute('data-chosen');
      }
    };
  };

  NameBox.prototype.form = function () {
    return this.input.form;
  };

  // The language the name must be written in ("Other" -> what the shopper typed, else English)
  NameBox.prototype.language = function () {
    var value = this.languageInput ? this.languageInput.value : 'English';
    if (value === 'Other') return (this.otherInput && this.otherInput.value.trim()) || 'English';
    return value || 'English';
  };

  NameBox.prototype.bind = function () {
    var box = this;
    this.root.addEventListener('click', function (event) {
      var pill = event.target.closest('[data-hn-lang]');
      if (pill) return box.chooseLanguage(pill.dataset.hnLang);
      var font = event.target.closest('[data-hn-font-choice]');
      if (font) return box.chooseFont(font.dataset.hnFontChoice);
    });

    this.input.addEventListener('input', function () {
      box.clearError();
      box.updateCount();
      box.translateSoon();
    });
    if (this.otherInput) {
      this.otherInput.addEventListener('input', function () {
        box.clearError();
        box.clearFonts();
        box.translateSoon();
      });
    }
    // Enter in the name / language box translates instead of adding to cart
    [this.input, this.otherInput].forEach(function (field) {
      if (!field) return;
      field.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          box.translateNow();
        }
      });
    });
  };

  NameBox.prototype.chooseLanguage = function (language) {
    this.root.querySelectorAll('[data-hn-lang]').forEach(function (pill) {
      pill.setAttribute('aria-pressed', pill.dataset.hnLang === language ? 'true' : 'false');
    });
    if (this.more) this.more.set(language);
    this.languageInput.value = language;
    var isOther = language === 'Other';
    if (this.otherBox) this.otherBox.hidden = !isOther;
    if (this.otherInput) this.otherInput.disabled = !isOther;
    this.clearError();
    this.clearFonts();
    this.updateSizeNote();
    if (this.input.value.trim()) this.translateNow();
  };

  NameBox.prototype.updateSizeNote = function () {
    if (this.size) this.size.textContent = sizeNote(this.languageInput ? this.languageInput.value : 'English');
  };

  NameBox.prototype.updateCount = function () {
    if (this.input.value.length > MAX_LENGTH) this.input.value = this.input.value.slice(0, MAX_LENGTH);
    var length = this.input.value.length;
    this.count.textContent = length + '/' + MAX_LENGTH; // turns red at the limit
    this.count.setAttribute('aria-label', length + ' of ' + MAX_LENGTH + ' characters');
    this.count.classList.toggle('hn-name__count--full', length >= MAX_LENGTH);
  };

  NameBox.prototype.translateSoon = function () {
    var box = this;
    clearTimeout(this.timer);
    this.translating = this.input.value.trim() !== '';
    this.timer = setTimeout(function () { box.translateNow(); }, 800);
  };

  NameBox.prototype.translateNow = async function () {
    clearTimeout(this.timer);
    var text = this.input.value;
    var language = this.language();
    var id = ++this.request;

    if (!text.trim()) {
      this.translating = false;
      this.done = { text: null, language: null, failed: false };
      this.clearFonts();
      this.show('', false);
      return;
    }

    this.translating = true;
    var result = await translate(text, language, this.endpoint);
    // Only the newest request may update the page, and only if name AND language are unchanged
    // (otherwise e.g. Punjabi letters could be saved as the Hindi name)
    if (id !== this.request || this.input.value !== text || this.language() !== language) return;

    this.translating = false;
    this.done = { text: text, language: language, failed: !result };
    var shown = result || text;
    if (!this.keepSpaces) shown = shown.replace(/\s+/g, '');
    this.drawFonts(shown, language);
    this.show(shown, !result);
    if (this.error.textContent && !this.problem()) this.clearError();
  };

  // Puts the name in the preview and in the order fields
  NameBox.prototype.show = function (shown, failed) {
    var language = this.done.language || this.language();
    this.preview.textContent = shown;
    this.preview.style.fontFamily = this.fontInput.value ? this.fontInput.value + ', Arial, sans-serif' : '';
    fitAll(this.root);
    // "We engrave exactly what you see" only when the name really is in the chosen script
    var promise = this.root.querySelector('.hn-name__promise');
    if (promise) promise.hidden = !!failed;

    var own = OWN_FIELD[language] || 'Other';
    var scriptText = failed ? '' : shown;
    this.root.querySelectorAll('[data-hn-script]').forEach(function (field) {
      field.value = field.dataset.hnScript === own ? scriptText : '';
    });
    this.note.value = failed && shown
      ? 'Not translated automatically - our team will write "' + this.done.text + '" in ' + language + ' letters'
      : '';
    this.notice.textContent = failed && shown
      ? "We couldn't convert your name to " + language + ' letters right now. You can type it in ' + language +
        ' letters yourself, or add to cart and our team will write it for you.'
      : '';
  };

  NameBox.prototype.clearFonts = function () {
    this.fontsBox.innerHTML = '';
  };

  NameBox.prototype.drawFonts = function (shown, language) {
    var box = this;
    var fonts = FONTS[language] || [];
    this.clearFonts();
    if (!fonts.length) {
      this.fontInput.value = ''; // e.g. "Other": no font choice
      return;
    }
    var current = this.fontInput.value;
    if (!fonts.some(function (f) { return f[0] === current; })) this.fontInput.value = fonts[0][0];

    fonts.forEach(function (font) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'hn-name__font';
      button.dataset.hnFontChoice = font[0];
      button.setAttribute('aria-pressed', font[0] === box.fontInput.value ? 'true' : 'false');
      var sample = document.createElement('span');
      sample.className = 'hn-name__font-sample';
      sample.style.fontFamily = font[0] + ', Arial, sans-serif';
      sample.textContent = shown;
      var label = document.createElement('span');
      label.className = 'hn-name__font-label';
      label.textContent = font[1];
      button.append(sample, label);
      box.fontsBox.appendChild(button);
    });
    fitAll(this.root);
  };

  NameBox.prototype.chooseFont = function (font) {
    this.fontInput.value = font;
    this.fontsBox.querySelectorAll('[data-hn-font-choice]').forEach(function (button) {
      button.setAttribute('aria-pressed', button.dataset.hnFontChoice === font ? 'true' : 'false');
    });
    this.preview.style.fontFamily = font + ', Arial, sans-serif';
    fitAll(this.root);
  };

  // ---------- Checks before Add to cart ----------
  NameBox.prototype.problem = function () {
    if (this.languageInput && this.languageInput.value === 'Other' && !this.otherInput.value.trim()) {
      return { field: this.otherInput, message: 'Please tell us which language you want.' };
    }
    if (!this.input.value.trim()) {
      return { field: this.input, message: 'Please enter a name before adding to cart.' };
    }
    if (this.translating || this.input.value !== this.done.text || this.language() !== this.done.language) {
      return { field: this.input, pending: true, message: 'One moment, we are still preparing your name. Please try again in a second.' };
    }
    if (this.fontsBox.querySelector('[data-hn-font-choice]') && !this.fontInput.value) {
      return { field: this.fontsBox, message: 'Please choose a font style.' };
    }
    return null;
  };

  NameBox.prototype.showError = function (problem) {
    this.error.textContent = problem.message;
    if (problem.field.tagName === 'INPUT') {
      problem.field.setAttribute('aria-invalid', 'true');
      problem.field.focus({ preventScroll: true });
    }
    // Always bring the problem into view (e.g. after tapping the Add to cart bar at the bottom of the screen)
    problem.field.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  NameBox.prototype.clearError = function () {
    this.error.textContent = '';
    [this.input, this.otherInput].forEach(function (field) {
      if (field) field.removeAttribute('aria-invalid');
    });
  };

  // Runs before the theme's product-form.js (capture phase), for the button and the Enter key alike
  document.addEventListener('submit', function (event) {
    boxes.forEach(function (box) {
      if (box.form() !== event.target) return;
      var problem = box.problem();
      if (problem) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (problem.pending) box.translateNow();
        box.showError(problem);
        return;
      }
      // Don't send empty translation fields to the cart
      box.root.querySelectorAll('[data-hn-script], [data-hn-note]').forEach(function (field) {
        field.disabled = field.value.trim() === '';
      });
    });
  }, true);

  var boxes = [];
  function init() {
    document.querySelectorAll('[data-hn-name]').forEach(function (root) {
      if (root.hnBox) return;
      root.hnBox = new NameBox(root);
      boxes.push(root.hnBox);
    });
    boxes = boxes.filter(function (box) { return document.contains(box.root); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init); // theme editor
})();
